// extracted by mini-css-extract-plugin
module.exports = {"swiperVideo":"SwiperVideo_swiperVideo__WQUms"};